import config from '@/config';

const ServiceIconMixin = {
  methods: {
    hasIcon(icon) {
      return this.$_.includes(config.ICOOL.SERVICE_ICON_COMPONENTS, icon);
    },
  },
};

export default ServiceIconMixin;
